/*
 * Геометрия страницы Comabooks (как в печати, backend services/pdfGeneratorComabooks.ts):
 * макет 1090.68 × 1625.68 «px» jsPDF (1068×1603 + поле 11.34), лист 126×186 мм —
 * по высоте срезается ≈7.8 px сверху и снизу. Шрифт jsPDF в pt → px макета: pt × 0.75.
 */
export const CHANGE = 11.34;
export const LAYOUT_W = 1068 + CHANGE * 2;
export const LAYOUT_H = 1603 + CHANGE * 2;
export const VISIBLE_H = (LAYOUT_W * 186) / 126;
export const CROP_Y = (LAYOUT_H - VISIBLE_H) / 2;
export const CX = 534 + CHANGE;

/** Длина в единицах макета → CSS (страница — контейнер inline-size). */
export const u = (n: number): string => `${((n * 100) / LAYOUT_W).toFixed(4)}cqw`;
/** pt шрифта jsPDF → CSS. */
export const pt = (n: number): string => u(n * 0.75);
/** Верх строки по базовой линии jsPDF (Playfair: baseline ≈ 0.99em при line-height 1.15). */
export const topFromBaseline = (y: number, fontPt: number, baselineEm = 0.99): string =>
  u(y - CROP_Y - fontPt * 0.75 * baselineEm);

export const formatPageDate = (s: string | null | undefined): string => {
  if (!s) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  return s;
};
